import React from 'react';
import { FemEntityLanding } from './pages/FemEntityLanding';
import { InvestorsPage } from './pages/InvestorsPage';
import { PractitionersPage } from './pages/PractitionersPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { AppLaunchPage } from './pages/AppLaunchPage';
import { PractitionerJoinPage } from './pages/PractitionerJoinPage';
import { PractitionerWelcomePage } from './pages/PractitionerWelcomePage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
export function App() {
  const path = window.location.pathname.replace(/\/+$/, '') || '/';
  if (path === '/investors') {
    return <InvestorsPage data-id="element-0" data-mp="31bianp7oiogh" />;
  }
  if (path === '/practitioners/join') {
    return <PractitionerJoinPage initialStep="account" data-id="element-1" data-mp="2wjqi594yq8np" />;
  }
  if (path === '/practitioners/membership') {
    return <PractitionerJoinPage initialStep="membership" data-id="element-2" data-mp="28tmi1bqzgr1g" />;
  }
  if (path === '/practitioners/welcome') {
    return <PractitionerWelcomePage data-id="element-3" data-mp="23u9vks40xlze" />;
  }
  if (path === '/terms-of-service') {
    return <TermsOfServicePage data-id="element-4" data-mp="3ikh9me1wn113" />;
  }
  if (path === '/practitioners') {
    return <PractitionersPage data-id="element-5" data-mp="3mlja0y7k5j4n" />;
  }
  if (path === '/privacy-policy') {
    return <PrivacyPolicyPage data-id="element-6" data-mp="3mjq2lgp4euvl" />;
  }
  if (path === '/get-the-app') {
    return <AppLaunchPage data-id="element-7" data-mp="3rdaq2et386gj" />;
  }
  return <FemEntityLanding data-id="element-8" data-mp="3rd19tixuhdo1" />;
}